{
    "welcome": "Velkommen",
    "getStarted": "Kom i gang"
}
